import React from 'react'
import { useTranslation } from 'next-i18next'
import { CustomCheckBox } from 'src/components'
import styles from './ProjectFormContentTaxRelief.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  setProjectFormItemValue,
  projectFormKindSelector,
  isTaxReliefSelector,
} from 'src/features'

const ProjectFormContentTaxRelief: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const kindSelected = useAppSelector(projectFormKindSelector)
  const isTaxRelief = useAppSelector(isTaxReliefSelector)

  return <>
    {kindSelected === 'contribution' && <div className={styles.content}>
      <CustomCheckBox
        defaultValue={isTaxRelief}
        handleChange={(value) => dispatch(setProjectFormItemValue({ key: 'is_tax_relief', value }))}
        text={t('Projects.Form.TaxReliefLabel')}
        isSmallText
      />
    </div>}
  </>
}

export default ProjectFormContentTaxRelief
